import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { useMediaQuery } from '@material-ui/core';
// import clsx from 'clsx';
import { Topbar } from './Topbar';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 64,
        height: '100%',
        [theme.breakpoints.down('md')]: {
            paddingTop: 0
        },
    },
    content: {
        height: '100%'
    },
    topBar : {
        paddingTop : 0
    }
}));

export const Minimal = (props) => {
    const { children } = props;
    const classes = useStyles();
    return (<div className={classes.root}>
      <Topbar />
      <main className={classes.content}>{children}</main>
    </div>);
};
